import React, { Component } from "react";
import {connect} from "react-redux";
import ShipmentStageOneNew from "./components/ShipmentDropdownStageOneNew"
import ShipmentStageTwoNew from "./components/ShipmentDropdownStageTwoNew"
import {Col, Row} from "react-bootstrap";
import './components/shipmentdropdown.css'
import Popup from "./components/LabelPopup";
import PDFViewer from "./PDFViewer";

const mapDispatchToProps = dispatch =>{
    return {
    }
};

const mapStateToProps = state => {
    return {loading:state.shippingState.isLoading};
};



class ShippingDropDownComponentNew extends Component {
    constructor(props) {
        super(props);
        this.state = {
            refresh: false,
            labelPopup:false
        };
    }

    componentDidMount() {
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // if shipment has ibt attached, show it for user to print once as this will be a requirement for rejecting
        if((prevProps.shipment.ibt !== this.props.shipment.ibt) && this.props.shipment.ibt.length > 0){
            this.setState({labelPopup:true})
        }
    }

    handleLabelClose =()=>{
        this.setState({labelPopup:!this.state.labelPopup});
    }
    render() {
        let shipment = this.props.shipment;
        let stageofship = shipment.labelsPrinted  ? 'STAGE_THREE' :
            shipment.status === "FULFILLED" ? 'STAGE_THREE' :
                shipment.stage ? shipment.stage : 'STAGE_ONE';
        let loading = this.props.loading;
        switch (stageofship) {
            case 'STAGE_ONE':
                if(shipment){
                    return (
                        <Row className={"dropdown-row"}>
                            <Col sm={12}>
                                    <ShipmentStageOneNew  onHold = {this.props.disabled} shipment={shipment} />
                            </Col>
                        </Row>
                    )
                }
            case 'STAGE_TWO':
            case 'STAGE_THREE':
                if(shipment){
                    return (
                                <Row className={"dropdown-row"}>
                                    {
                                        this.props.shipment.ibt && this.state.labelPopup ?
                                            <Popup
                                                handleClose={this.handleLabelClose}
                                                content={
                                                    <PDFViewer pdfUrl={this.props.shipment.ibt} />
                                                }
                                            />
                                            :null
                                    }
                                    <Col sm={12}>
                                        <div>
                                            <ShipmentStageTwoNew labelsPrinted={!!shipment.labelsPrinted} shipment={shipment} stage={stageofship} collection={shipment.method === "CLICKCOLLECT"}/>
                                        </div>
                                    </Col>
                                </Row>
                    )
                }
            case 'STAGE_COMPLETE':
                if(shipment && !loading){
                    return (
                        <div>
                            {/* {
                                this.props.shipment.ibt && this.state.labelPopup ?
                                    <Popup
                                        handleClose = {this.handleLabelClose}
                                        content={
                                            <iframe id={"labelprint"} type="application/pdf" name={"ibtprint"} width="100%" height="100%" src={this.props.shipment.ibt} style={{display:"block"}}/>
                                        }
                                    />
                                    :null
                            } */}
                            <p>This order is now complete and will be removed from this list on refresh</p>
                        </div>
                    )
                }else {
                    return (
                        <div>
                            <div className="loading-spinner loading-spinner-blue"></div>
                        </div>
                    )
                }
        }


    }
}

export default connect(mapStateToProps,mapDispatchToProps)(ShippingDropDownComponentNew)